exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a1c6b6a","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=1!./src/plugin/vue-magnifier.vue
// module id = 9
// module chunks = 0